<template>
  <div class="flex flex-col p-3">
    <div class="w-full bg-white rounded-sm text-gray">
      <div class="border-b border-gray-200 mb-4">
        <nav class="flex space-x-6 px-4" aria-label="Tabs">
        <div :class="[(currentRoute === 'client') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('client')">
          <div class="flex">
            <div>Client Accounts</div>
            <span class="text-primary font-bold px-2">
                {{ store.client_accounts_count }}
              </span>
          </div>
        </div>
        <div :class="[(currentRoute === 'business') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('business')">
          <div class="flex">
            <div>Business Accounts</div>
            <span class="text-primary font-bold px-2">
                {{ store.business_accounts_count }}
              </span>
          </div>
        </div>
        <div :class="[(currentRoute === 'backoffice') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('backoffice')">
          <div class="flex">
            <div>Backoffice Accounts</div>
            <span class="text-primary font-bold px-2">
                {{ store.officer_accounts_count }}
              </span>
          </div>
        </div>
        <div :class="[(currentRoute === 'mda') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('mda')">
          <div class="flex">
            <div>MDA Accounts</div>
            <span class="text-primary font-bold px-2">
                {{ store.mda_accounts_count }}
              </span>
          </div>
        </div>
        <div :class="[(currentRoute === 'private-organisations') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('private-organisations')">
          <div class="flex">
            <div>Private Organisations</div>
            <span class="text-primary font-bold px-2">
                {{ store.private_organisations_accounts_count }}
              </span>

          </div>
        </div>
        <div :class="[(currentRoute === 'official-receiver') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('official-receiver')">
          <div class="flex">
            <div>Official Receivers</div>
            <span class="text-primary font-bold px-2">
                {{ store.officer_accounts_count }}
              </span>

          </div>
        </div>
        </nav>
      </div>

      <div class="flex flex-col">
        <ClientAccounts v-if="currentRoute === 'client'"/>
        <BackofficeAccounts v-if="currentRoute === 'backoffice'"/>
        <BusinessAccounts v-if="currentRoute === 'business'"/>
        <PartnerAccounts v-if="currentRoute === 'partner'"/>
        <MDAAccounts v-if="currentRoute === 'mda'"/>
        <PrivateOrganisationAccounts v-if="currentRoute === 'private-organisations'"/>
        <OfficialReceiverAccounts v-if="currentRoute === 'official-receiver'"/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import ClientAccounts from "@/domains/home/services/accounts/views/ClientAccounts.vue";
import BackofficeAccounts from "@/domains/home/services/accounts/views/BackofficeAccounts.vue";
import BusinessAccounts from "@/domains/home/services/accounts/views/BusinessAccounts.vue";
import PartnerAccounts from "@/domains/home/services/accounts/views/PartnerAccounts.vue";
import MDAAccounts from "@/domains/home/services/accounts/views/MDAAccounts.vue";
import PrivateOrganisationAccounts from "@/domains/home/services/accounts/views/PrivateOrganisationAccounts.vue";
import OfficialReceiverAccounts from "@/domains/home/services/accounts/views/OfficialReceiverAccounts.vue";
import { useAccountStore } from "@/domains/home/services/accounts/stores";

type RouteType = 'client' | 'backoffice' | 'business' | 'partner' | 'mda' | 'private-organisations' | 'official-receiver'

const store = useAccountStore();

const currentRoute = ref<RouteType>('client')

onMounted(() => {

})

const select = (route: RouteType) => {
    currentRoute.value = route
}

</script>
